const RESOURCE_NAME = '/users-objects-templates';
import restApi from "@/api/rest-api-object";
export default axios => ({
    ...restApi(axios, RESOURCE_NAME),

    templatesByType(type, params) {
        return axios.get(`${RESOURCE_NAME}/${type}`, {params});
    }
});